import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import '@angular/common/locales/global/sl';
import { VpoVpogledHttpInterceptor } from 'projects/vpo-shared/src/lib/interceptors/vpoVpogledHttpInterceptor';
import { sharedConfig } from 'projects/vpo-shared/src/lib/config/shared.config';
import { httpBlockInterceptor } from 'projects/vpo-shared/src/lib/block-ui/http-block-interceptor';

export const appConfig: ApplicationConfig = {
  ...sharedConfig,
  providers: [
    provideRouter(routes),
    sharedConfig.providers,
    provideHttpClient(withInterceptors([httpBlockInterceptor]), withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: VpoVpogledHttpInterceptor,
      multi: true,
    },
  ],
};
